import React from 'react';
import { Button, Typography, Box } from '@mui/material';

const PaginationControls = ({ currentPage, totalPages, onChangePage }) => {
  return (
    <Box display="flex" justifyContent="center" mt={2}>
      <Button
        onClick={() => onChangePage(0)}
        disabled={currentPage === 0}
      >
        First
      </Button>
      <Button
        onClick={() => onChangePage(currentPage - 1)}
        disabled={currentPage === 0}
      >
        {currentPage > 0 ? currentPage : ''}
      </Button>
      <Typography variant="body1" style={{ margin: '0 16px' }}>
        {currentPage + 1} / {totalPages}
      </Typography>
      <Button
        onClick={() => onChangePage(currentPage + 1)}
        disabled={currentPage >= totalPages - 1}
      >
        {currentPage < totalPages - 1 ? currentPage + 2 : ''}
      </Button>
      <Button
        onClick={() => onChangePage(totalPages - 1)}
        disabled={currentPage >= totalPages - 1}
      >
        Last
      </Button>
    </Box>
  );
};

export default PaginationControls;
